export const CHAT_THEME = {
	PAPER: 'paper',
	LIGHT: 'light',
	DARK: 'dark',
} as const;

export type ChatTheme = (typeof CHAT_THEME)[keyof typeof CHAT_THEME];

export const CHAT_THEME_OPTIONS: Array<{ key: ChatTheme; label: string }> = [
	{ key: CHAT_THEME.PAPER, label: 'Paper' },
	{ key: CHAT_THEME.LIGHT, label: 'Light' },
	{ key: CHAT_THEME.DARK, label: 'Dark' },
];

export const CHAT_PANEL_WIDTH = {
	DEFAULT: 560,
	MIN: 280,
	MAX: 720,
	COLLAPSE_THRESHOLD: 240,
	RAIL: 40,
	DRAG_THRESHOLD: 3,
} as const;
